export default {
  label: {
    id: 'langselector_language',
    defaultMessage: 'Language',
  },
}
